// @ts-nocheck
import { FormHelperText, Select, Grid } from "@chakra-ui/react";
import React, { useState } from "react";
import { SCHEDULE_DATA } from "../../utils/data";
import Section from "../layout/Section";

function transformInput(input) {
  let inputArray = input.split("-");
  return { year: inputArray[0], month: inputArray[1], day: inputArray[2] };
}

function generateDayOptions() {
  let options = [];
  for (let i = 1; i < 32; i++) {
    options = [...options, i];
  }
  return options.map((num) => {
    let numValue = num < 10 ? `0${num}` : num.toString();
    return { label: num, value: numValue };
  });
}

let months = SCHEDULE_DATA.monthsOfTheYear.map((month) => month.longName);
let monthOptions = months.map((month) => {
  let monthValue = months.indexOf(month) + 1;
  let formattedValue =
    monthValue < 10 ? `0${monthValue}` : monthValue.toString();
  return {
    label: month,
    value: formattedValue,
  };
});

function generateYearOptions(minAge = 13, maxAge = 60) {
  let currentYear = new Date().getFullYear();
  let startYear = currentYear - maxAge;
  let endYear = currentYear - minAge;
  let options = [];
  for (let i = startYear; i < endYear + 1; i++) {
    options = [...options, i];
  }

  return options.map((item) => ({ label: item, value: item.toString() }));
}

let defaultPlaceholders = {
  day: {
    // label: "Day",
    errorMessage: "Select a day",
    placeholder: "Day",
  },
  month: {
    // label: "Month",
    errorMessage: "Select a month",
    placeholder: "Month",
  },
  year: {
    // label: "Year",
    errorMessage: "Select a year",
    placeholder: "Year",
  },
};

let emptyValue = { day: "", month: "", year: "" };

const BirthDayField = ({
  helpText,
  value: valueProp,
  onChange,
  minimumAge,
  maximumAge,
  years = [],
  ...rest
}) => {
  const initialValue = valueProp ? transformInput(valueProp) : {};
  const [value, setValue] = useState(initialValue || emptyValue);
  const options =
    years.length > 0 ? years : generateYearOptions(minimumAge, maximumAge);

  const saveValue = (data) => {
    setValue(data);
    let outputValue = `${data.year}-${data.month}-${data.day}`;
    onChange && onChange(outputValue);
  };

  const handleChange = (key, selectedOption) => {
    let oldValues = value || {};
    let newValues = { ...oldValues, [key]: selectedOption };
    saveValue(newValues);
  };

  return (
    <Section className="Zeta-BirthDayField">
      <FormHelperText mb={2} fontSize="sm">
        {helpText}
      </FormHelperText>
      <Grid
        templateColumns={["none", "2fr 3fr 2fr"]}
        columnGap={[0, 3]}
        rowGap={[3, 0]}
      >
        <Select
          onChange={(e) => handleChange("day", e.target.value)}
          value={value.day}
          {...defaultPlaceholders.day}
          {...rest}
        >
          {generateDayOptions().map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </Select>
        <Select
          onChange={(e) => handleChange("month", e.target.value)}
          value={value.month}
          {...defaultPlaceholders.month}
          {...rest}
        >
          {monthOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </Select>
        <Select
          onChange={(e) => handleChange("year", e.target.value)}
          value={value.year}
          {...defaultPlaceholders.year}
          {...rest}
        >
          {years.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </Select>
      </Grid>
    </Section>
  );
};

export default BirthDayField;
